import { forwardRef, ComponentProps } from "react";
import { useRHFAdapter } from "@shared/features/form/useRHFAdapter";
import {
  FieldBaseProps,
  useFieldProps,
} from "@shared/features/form/useFieldProps";

export type Props = ComponentProps<"input"> &
  FieldBaseProps & {
    name: string;
    transformOnChange?: (val: string) => string;
  };

export const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      className,
      isLoading,
      isSubmitting,
      type = "text",
      error,
      prefix,
      disabled,
      isWithIcon,
      onChange,
      onBlur,
      transformOnChange,
      placeholder,
      required,
      autoComplete,
    },
    ref
  ) => {
    const { inputProps } = useRHFAdapter({
      name,
      onChange,
      onBlur,
      transformEvent: (e) => {
        if (transformOnChange && e?.target?.value != null) {
          e.target.value = transformOnChange(e.target.value);
        }
        return e;
      },
    });

    const fieldProps = useFieldProps({
      className,
      error,
      isLoading,
      isSubmitting,
      required,
      isWithIcon,
      prefix,
    });

    return (
      <input
        name={name}
        type={type}
        id={name}
        data-testid={`input-${name}`}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        {...fieldProps}
        {...inputProps}
        ref={(el) => {
          inputProps.ref(el); // RHF needs this
          if (typeof ref === "function") ref(el); // forwarded ref
        }}
      />
    );
  }
);

Input.displayName = "Input";

export default Input;
